module.exports = __webpack_public_path__ + "img/sinclair catalog 1984 p11.9647d663.jpg";